document.addEventListener("DOMContentLoaded", function () {
  if (window.marketCountry !== "GB") return;

  var formattedPrices = new WeakMap();
  var scheduled = false;

  function updatePrices() {
    scheduled = false;
    document.querySelectorAll(".price-item").forEach(function (element) {
      if (formattedPrices.get(element) === element.innerHTML) return;
      var source = element.textContent.trim();
      var amounts = source.replace(/,/g, "").match(/\d+(?:\.\d+)?/g);
      if (!amounts || amounts.length !== 1) return;
      var price = Number(amounts[0]);
      if (!Number.isFinite(price)) return;
      var from = /\bFrom\b/i.test(source) ? "From " : "";
      var container = document.createElement("div");
      var exclusive = document.createElement("span");
      exclusive.textContent = from + "£" + price.toFixed(2) + " ex VAT";
      var inclusive = document.createElement("small");
      inclusive.textContent = "(" + from + "£" + (price * 1.2).toFixed(2) + " incl VAT)";
      container.append(exclusive, document.createElement("br"), inclusive);
      element.replaceChildren(container);
      formattedPrices.set(element, element.innerHTML);
    });
  }

  updatePrices();
  new MutationObserver(function (mutations) {
    var priceChanged = mutations.some(function (mutation) {
      var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (target && target.closest(".price-item")) return true;
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches(".price-item") || node.querySelector(".price-item"));
      });
    });
    if (priceChanged && !scheduled) {
      scheduled = true;
      requestAnimationFrame(updatePrices);
    }
  }).observe(document.body, { childList: true, characterData: true, subtree: true });
});
